const landingPageNordEn = {
    // Main hero section
    hero: {
        title: "Your internet is <span class='text-red-500'>not secured!</span>\nSecure your connection\ntoday with <span class='text-blue-600'>NordVPN!</span>",
        subtitle: "Welcome to a world where your online privacy is paramount, and your digital life is your own. Discover how NordVPN can safeguard your every click and keystroke",
        primaryButton: "Secure my IP now",
        secondaryButton: "Buy NordVPN",
        noCardRequired: "No card is required",
        moneyBackGuarantee: "30-day money-back guarantee"
    },

    // Stats section
    stats: {
        vpnServers: "VPN Servers",
        usersWorldwide: "Users worldwide",
        countries: "Countries"
    },

    // Why Us section
    whyUs: {
        sectionTitle: "WHY US?",
        title: "Why do users choose NordVPN?",
        subtitle: "NordVPN is a reliable VPN provider with a range of features that enhance your security, privacy, and freedom online.",
        features: {
            onlineSecurity: "Online Security",
            hideYourIp: "Hide Your IP",
            fastestVpn: "Fastest VPN",
            globalCoverage: "Global Coverage",
            multipleDevices: "Multiple Devices",
            noUserTracking: "No User Tracking"
        },
        button: "Get started now"
    },

    // Trusted section
    trusted: {
        sectionTitle: "WE ARE TRUSTED",
        title: "Join millions who trust NordVPN<br class='hidden lg:block'> to protect their security",
        testimonials: [
            {
                name: "Alch3m1st",
                handle: "@Alch3m1s7",
                text: "@NordVPN the new meshnet is mind-blowingly amazing piece of tech 🚀, with unlimited bottomless use cases. God bless ya all! 🙌",
                avatar: "male"
            },
            {
                name: "Nathan Corliss",
                handle: "@MrNathanCorliss",
                text: "This is completely unsolicited praise, <span class='text-blue-600'>@NordVPN</span>, is very helpful as an advertiser testing search ads, and as a work-anywhere person who needs to ensure I have a safe internet connection. Great value. So easy to use, I actually use it. Keep up the good work.",
                avatar: "male1"
            },
            {
                name: "Pedro",
                handle: "@PedroTheKiwi",
                text: "I've been using NordVPN and their other products for the last 4 years. Absolutely outstanding product and service",
                avatar: "male2"
            }
        ],
        button: "Buy NordVPN"
    },

    // How to use section
    howToUse: {
        sectionTitle: "HOW TO USE",
        title: "Click, connect, stay protected",
        subtitle: "How to use NordVPN in 3 easy steps.",
        steps: {
            step1: {
                title: "Buy NordVPN",
                description: "<span style='color: #3E5FFF'>Choose the plan that suits you</span> and <span style='color: #3E5FFF'>create an account.</span>"
            },
            step2: {
                title: "Download the app",
                description: "Download the <span style='color: #3E5FFF'>NordVPN app</span> for your device."
            },
            step3: {
                title: "Connect to VPN",
                description: "Select a VPN server and connect."
            }
        },
        button: "Buy NordVPN"
    },

    // Pricing section
    pricing: {
        sectionTitle: "PRICING",
        title: "Get NordVPN via carrier direct debit today!",
        subtitle: "Your digital life protected for BGN 24.00 with VAT per month",
        planName: "Standard",
        price: "BGN 0.8",
        priceUnit: "/day",
        vatNotice: "VAT may apply",
        features: [
            "Secure and high-speed VPN",
            "Threat Protection Pro™: Anti-malware protection and advanced online security",
            "Threat Protection Pro™: Ad and Tracker Blocker"
        ],
        button: "Buy NordVPN",
        guarantees: {
            moneyBack: "30-day money-back guarantee",
            noCard: "No card is required"
        }
    },

    // Hassle-free section
    hassleFree: {
        title: "Hassle-free setup and 30-day money-back guarantee",
        subtitle: "Enjoy full access to a premium VPN without any risks. If you are not 100% satisfied, let us know within 30 days of purchasing NordVPN and get a full refund.",
        button: "Try NordVPN risk-free"
    },

    // FAQ section
    faq: {
        sectionTitle: "FAQ",
        title: "Frequently asked questions",
        questions: [
            {
                question: "How does the carrier direct debit process work?",
                answer: "Welcome to a world where your privacy online is paramount, and your digital life is your own. Discover how NordVPN can protect every click and keystroke."
            },
            {
                question: "Is NordVPN legal to use?",
                answer: "Yes, it is legal to use a VPN in most countries. However, it is your responsibility to ensure that you are not engaging in any illegal activities while using the VPN."
            },
            {
                question: "Why do I need to pay for a VPN service?",
                answer: "Free VPNs often have limitations, such as slower speeds, data caps, and fewer server locations. Paid VPNs like NordVPN offer a more reliable and secure service with unlimited bandwidth and a large server network."
            },
            {
                question: "Can I use NordVPN while traveling abroad?",
                answer: "Yes, you can use NordVPN to access your favorite content and services from anywhere in the world. It helps you bypass geo-restrictions and censorship."
            },
            {
                question: "What devices does NordVPN support?",
                answer: "NordVPN supports a wide range of devices, including Windows, macOS, iOS, Android, Linux, and more. You can protect up to 6 devices with a single subscription."
            },
            {
                question: "How to contact NordVPN support?",
                answer: "You can contact our customer support team 24/7 via live chat or email. We are always here to help you with any questions or issues you may have."
            }
        ]
    },

    // Footer section
    footer: {
        links: {
            privacyPolicy: "Privacy Policy",
            termsOfUse: "Terms of Use",
            cookiePolicy: "Cookie Policy",
            dpi: "DPI",
            contact: "Contact"
        }
    },

    // Step forms
    steps: {
        moneyBackGuarantee: "30-day money-back guarantee"
    }
};

export default landingPageNordEn; 